import createCache from "@emotion/cache";
import { cspNonce } from "@/lib/csp-style-nonce";

/** Shared Emotion cache so react-select / MUI <style> tags get the CSP nonce. */
export const emotionCache = createCache({
    key: "css",
    nonce: cspNonce,
    prepend: true,
});
